import { Grid } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SectionBox } from "src/pages/sistema/components/FieldView";
import { dateFormatter } from "src/utils/formatters";
import { OperacionAFOCLFields } from '../types/fields';
import { OperacionAFOCL } from "../types/types";

type SeccionAFOCLDatosOperacionProps = {
  operacion?: OperacionAFOCL;
}

const SeccionAFOCLDatosOperacion = ({ operacion }: SeccionAFOCLDatosOperacionProps) => {
  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      {operacion && (
        <SectionBox>
          <Grid item xs={12} md={2}>
            <FieldView label='País' value={operacion[OperacionAFOCLFields.NombrePais]} />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView
              label='Usuario Alta'
              value={`${operacion[OperacionAFOCLFields.NombreUsuarioAlta]} ${operacion[OperacionAFOCLFields.ApellidoUsuarioAlta]}`}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView label='Unidad de Negocio' value={operacion[OperacionAFOCLFields.DescUnidadNegocio]} />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView label='Equipo Comercial' value={operacion[OperacionAFOCLFields.DescSectorComercial]} />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView
              label='Fecha de Solicitud'
              value={operacion[OperacionAFOCLFields.FechaSolicitud]
                ? dateFormatter.toShortDate(operacion[OperacionAFOCLFields.FechaSolicitud])
                : undefined}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView
              label='Fecha de Vencimiento'
              value={operacion[OperacionAFOCLFields.FechaVencimiento]
                ? dateFormatter.toShortDate(operacion[OperacionAFOCLFields.FechaVencimiento])
                : undefined}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView label='Número de Cuenta Comitente' value={operacion[OperacionAFOCLFields.NumeroCuenta]} />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView label='Razón Social' value={operacion[OperacionAFOCLFields.RazonSocial]} />
          </Grid>
          <Grid item xs={12}>
            <FieldView label='Observaciones' value={operacion[OperacionAFOCLFields.Observaciones]} />
          </Grid>
        </SectionBox>
      )}
    </CardActions>
  );
}

export default SeccionAFOCLDatosOperacion;